import { useCallback, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { getCoachPendingAction } from "@/api/coachingApi";
import { TRAINING_PLAN_DRAFT_READY_EVENT } from "@/lib/coachingActionGuard";
import { ACTIVE_PLAN_CHANGED_EVENT } from "@/lib/activePlanSync";
import { normalizeCoachPendingAction } from "@/lib/coachPendingAction";

export const coachPendingActionQueryKey = () => ["coach-pending-action"];

export const useCoachPendingAction = () => {
  const query = useQuery({
    queryKey: coachPendingActionQueryKey(),
    queryFn: ({ signal }) => getCoachPendingAction({ signal }),
    staleTime: 30_000,
    retry: (failureCount, error) => {
      if (error?.status === 401 || error?.status === 403) return false;
      return failureCount < 1;
    },
  });

  const refetch = query.refetch;

  const onLifecycleChange = useCallback(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    window.addEventListener(ACTIVE_PLAN_CHANGED_EVENT, onLifecycleChange);
    window.addEventListener(TRAINING_PLAN_DRAFT_READY_EVENT, onLifecycleChange);
    return () => {
      window.removeEventListener(ACTIVE_PLAN_CHANGED_EVENT, onLifecycleChange);
      window.removeEventListener(TRAINING_PLAN_DRAFT_READY_EVENT, onLifecycleChange);
    };
  }, [onLifecycleChange]);

  const normalized = normalizeCoachPendingAction(query.data);
  return {
    ...query,
    pendingCount: normalized.pendingCount,
    primary: normalized.primary,
  };
};
